const get = store => store.productVariant || {};
const getBarcodeScan = store => store.barcodeScan || {};
export const search = store => (store ? store : { data: [] });
export const getProductVariant = store => get(store).productVariant;
export const isLoaded = store => get(store).isLoaded === true;
export const getSelectionCount = store => get(store).selectionCount;
export const getBarcodeScanResult = store => getBarcodeScan(store).productVariant;
export const isBarcodeScanLoaded = store => getBarcodeScan(store).isLoaded === true;
export const getBarcodeScanError = store => getBarcodeScan(store).error;
